import React from "react";

function Toggle({defaultChecked, onToggleChange}) {

  return (
    <label className="switch">
      <input type="checkbox" onClick={(e) => onToggleChange(e)} defaultChecked={defaultChecked}/>
      <span className="slider round"/>
    </label>
  );
}

export default Toggle;
